"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _googleMapsReact = require("google-maps-react");

var _reactGeocode = _interopRequireDefault(require("react-geocode"));

require("./map-multilocation.css");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var MapMultilocation = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(MapMultilocation, _React$Component);

  var _super = _createSuper(MapMultilocation);

  function MapMultilocation(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, MapMultilocation);
    _this = _super.call(this, props);
    _this.state = {
      markers: [],
      activeMarker: null,
      bounds: null,
      showingInfoWindow: false
    };
    _this.onMarkerClick = _this.onMarkerClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onMapClicked = _this.onMapClicked.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(MapMultilocation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var apiKey = process.env.STORYBOOK_MAPS_API_KEY;
      var locations = this.props.locations;
      locations.forEach(function (location) {
        var address = _this2.getAddressFromLocation(location);

        _reactGeocode["default"].fromAddress(address, apiKey).then(function (geocodeData) {
          _this2.addMarker(location, address, geocodeData);
        });
      });
    }
  }, {
    key: "onMarkerClick",
    value: function onMarkerClick(props, marker, e) {
      this.setState({
        activeMarker: marker,
        showingInfoWindow: true
      });
    }
  }, {
    key: "onMapClicked",
    value: function onMapClicked(props) {
      var showingInfoWindow = this.state.showingInfoWindow;

      if (showingInfoWindow) {
        this.setState({
          activeMarker: null,
          showingInfoWindow: false
        });
      }
    }
  }, {
    key: "getAddressFromLocation",
    value: function getAddressFromLocation(location) {
      var street = location.street,
          city = location.city,
          state = location.state,
          zip_code = location.zip_code,
          country = location.country;
      return "".concat(street, ", ").concat(city, ", ").concat(state, ", ").concat(zip_code, ", ").concat(country);
    }
  }, {
    key: "addMarker",
    value: function addMarker(location, address, geocodeData) {
      var latLongData = geocodeData.results[0].geometry.location;
      var markers = this.state.markers;
      var newMarkers = [];
      newMarkers.push.apply(newMarkers, (0, _toConsumableArray2["default"])(markers));
      newMarkers.push({
        key: newMarkers.length,
        title: location.location_name,
        address: address,
        lat: latLongData.lat,
        lng: latLongData.lng
      });
      this.updateBounds(newMarkers);
      this.setState({
        markers: newMarkers
      });
    }
  }, {
    key: "updateBounds",
    value: function updateBounds(markers) {
      var bounds = new window.google.maps.LatLngBounds();
      markers.forEach(function (marker) {
        var latLng = new window.google.maps.LatLng(marker.lat, marker.lng);
        bounds.extend(latLng);
      });
      this.setState({
        bounds: bounds
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var google = this.props.google;
      var _this$state = this.state,
          bounds = _this$state.bounds,
          markers = _this$state.markers,
          activeMarker = _this$state.activeMarker,
          showingInfoWindow = _this$state.showingInfoWindow;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "map-multilocation-wrapper"
      }, /*#__PURE__*/_react["default"].createElement(_googleMapsReact.Map, {
        google: google,
        bounds: bounds,
        zoom: 16,
        onClick: this.onMapClicked
      }, markers.map(function (mrkr) {
        return /*#__PURE__*/_react["default"].createElement(_googleMapsReact.Marker, {
          key: mrkr.key,
          onClick: _this3.onMarkerClick,
          title: mrkr.title,
          address: mrkr.address,
          position: {
            lat: mrkr.lat,
            lng: mrkr.lng
          }
        });
      }), /*#__PURE__*/_react["default"].createElement(_googleMapsReact.InfoWindow, {
        marker: activeMarker,
        visible: showingInfoWindow
      }, /*#__PURE__*/_react["default"].createElement("div", null, activeMarker && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("h4", {
        style: {
          marginBottom: '0'
        }
      }, activeMarker.title), /*#__PURE__*/_react["default"].createElement("p", null, activeMarker.address))))));
    }
  }]);
  return MapMultilocation;
}(_react["default"].Component);

MapMultilocation.propTypes = {
  locations: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    street: _propTypes["default"].string.isRequired,
    city: _propTypes["default"].string.isRequired,
    state: _propTypes["default"].string.isRequired,
    zipCode: _propTypes["default"].string.isRequired,
    country: _propTypes["default"].string
  }))
};
MapMultilocation.defaultProps = {
  locations: []
};

var _default = (0, _googleMapsReact.GoogleApiWrapper)({
  apiKey: process.env.GOOGLE_MAPS_API_KEY
})(MapMultilocation);

exports["default"] = _default;